// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__37x-E","GithubContainer":"Footer_GithubContainer__3I0ux"};